//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_TIPO_SOCIOS = "obtenerTipoSocios";
export const OBTENER_TIPO_SOCIO = "obtenerTipoSocio";
export const REGISTRAR_TIPO_SOCIO = "registrarTipoSocio";
export const ACTUALIZAR_TIPO_SOCIO = "actualizarTipoSocio";
// mutation types
export const SET_TIPO_SOCIOS = "setTipoSocios";
export const SET_TIPO_SOCIO = "setTipoSocio";

const state = {
    tipoSocios: [],
    tipoSocio:[],
}

const getters = {
    obtenerTipoSocios(state) {
      return state.tipoSocios;
    },
}

const actions = {
    async [OBTENER_TIPO_SOCIOS](context, estadoId) {

        /*
        * Si el estado es null va a traer a todas las etnias, de lo contrario va a traer los etnias por estado
        *
        */
        let endpoint = 'api/Tipo_Socios'
        if(estadoId){
            endpoint = `api/Tipo_Socios/GetTipoSocioActivas/${estadoId}`
        }

        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_TIPO_SOCIOS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch(() => {
                });
        });       
    },

    

    async [OBTENER_TIPO_SOCIO](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Tipo_Socios/`)
                .then(({ data }) => {
                    context.commit(SET_TIPO_SOCIO, data.data);
                    resolve(data)
                })
                .catch(() => {
                });
        });    
    },
        async [REGISTRAR_TIPO_SOCIO](context, datosTipoSocio){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Tipo_Socios`, datosTipoSocio)
                .then(({ data }) => {
                    context.commit(SET_TIPO_SOCIOS, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                });
        });   
    },
    async [ACTUALIZAR_TIPO_SOCIO](context, datosTipoSocio){
        let id = datosTipoSocio.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Tipo_Socios/UpdateTipoSocios/`, datosTipoSocio)
                .then(({ data }) => {
                    context.commit(SET_TIPO_SOCIO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                });
        });    
    }
  }

const mutations = {
    [SET_TIPO_SOCIOS](state, data) {
        state.tipoSocios = data;
    },

    [SET_TIPO_SOCIO](state, data) {
        state.tipoSocio = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}